import React, {Component} from 'react';
import UsuariosRegistrados from './UsuariosRegistrados';
import ViajesUsuarios from './ViajesUsuarios';
import ViajesConductor from './ViajesConductor';
import GananciaSocio from './GanaciaSocio';
import ReporteTemplate from './ReporteTemplate';
import ReporteConductores from './ReporteConductores';
import ReporteVehiculos from './ReporteVehiculos';
import SociosGanancias from './SociosGanancias';
import ViajesEmpresas from '../ViajesEmpresas/ViajesEmpresas';
import Calicacion from './ReporteCalificacionGlobal';
import CalicacionViaje from './ReporteCalificaciones';
import ReporteAsignacionViajes from './ReporteAsignacionViajes';
import ReporteNew from './ReporteNew';

import store from '../../store';

class Reportes extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			reporte:'Viajes por conductor'
			
		}
		
		this.handleChange=this.handleChange.bind(this);
		this.renderContent=this.renderContent.bind(this);
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
	}
	
	
	
	handleChange(){
		
		
		let combo=this.combo.value;
		
		this.setState({
			
			reporte:combo
			
		})
		
	}
	
	renderContent(){
		
		/*
		if(this.state.reporte==='Viajes por usuario'){
			
			return <ViajesUsuarios/>
			
		}
		*/
		if(this.state.reporte==='Viajes por conductor'){
			
			return <ViajesConductor/>
			
		}
		else if(this.state.reporte==='Ganancias por socio'){
			
			return <GananciaSocio/>
		}
		else if(this.state.reporte==='Reporte de conductores'){
			
			return <ReporteConductores/>
			
		}
		else if(this.state.reporte==='Reporte de vehiculos'){
			
			return <ReporteVehiculos/>
			
		}
		else if(this.state.reporte==='Reporte de socios'){
			
			return <SociosGanancias/>
			
		}
		else if(this.state.reporte==='Viajes por empresas'){
			
			return <ViajesEmpresas/>
			
		}
		else if(this.state.reporte==='Reporte de calificacion'){
			
			return <Calicacion/>
			
		}
		else if (this.state.reporte === 'Reporte de asignacion de viajes') {
			return <ReporteAsignacionViajes />
		}
		else if (this.state.reporte === 'Reporte Nuevo') {
			return <ReporteNew />
		}
		/*
		else if(this.state.reporte==='Reporte de calificacion x viaje'){
			
			return <CalicacionViaje/>
			
		}
		*/
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	render(){
		
		return(
		
			<div className="Reportes container" onClick={this.ocultarMenu}>
				
		
					<h1 className="titulo">Reportes</h1>
				
					<div className="form-group row ">
						
						<div className="col-md-3">
							<select className="form-control" ref={input => {this.combo=input;}} onChange={this.handleChange}>
						
									{/*<option>Viajes por usuario</option>*/}						
									<option>Viajes por conductor</option>
									<option>Viajes por empresas</option>
									<option>Ganancias por socio</option>
									<option>Reporte de conductores</option>
									<option>Reporte de vehiculos</option>
									<option>Reporte de socios</option>
									<option>Reporte de calificacion</option>
									{/*<option>Reporte de calificacion x viaje</option>*/}
							</select>
						</div>
					</div>
					
					{this.renderContent()}
				
			
			</div>
		
		
		)
	}
}


export default Reportes;


// WEBPACK FOOTER //
// ./src/Components/Reportes/Reportes.jsx